import '../../css/misc/contactform.css';
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Col, Row } from 'react-bootstrap';
import { setContactProcessed } from '../../redux/interactionsSlice';
import ChatsService from '../../controllers/ChatController';
class ContactForm extends Component {

    constructor(props) {
        super(props);
        this.handleMessage = this.handleMessage.bind(this);
    }

    componentDidMount() {
        window.addEventListener("message", this.handleMessage);
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessage);
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.selectedForm !== this.props.selectedForm;
    }

    handleMessage(event) {
        console.log("ContactForm handleMessage: ", event.data);
        if (event.data.Method === "SetFormChange" && event.data.Status === "CLOSE") {
            ChatsService.setContactProcessed(this.props.interaction.id, false, e => {
                this.props.setContactProcessed(this.props.interaction.id);
            })
        }
    }

    render() {
        return (
            <>
                <Row>
                    <Col style={{ height: "70vh" }}>
                        <iframe title="contacts" src={`${this.props.selectedForm}`} width={"100%"} height={"100%"}></iframe>
                    </Col>
                </Row>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        interaction: state.interaction.current,
        selectedForm: state.agent.selectedForm
    };
};

export default compose(connect(mapStateToProps, { setContactProcessed }), withTranslation())(ContactForm);